import { call, put, select } from 'redux-saga/effects';
import { signalingPollLaunched } from 'features/polls/actions';
import { closeSharedPollNotificationSaga } from 'features/polls/sagas/closeSharedPollNotificationSaga';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { SidePanelType } from 'features/side-panels/types';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';
import { Action } from '@reduxjs/toolkit';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import i18n from 'i18n';
import { FeatureFlag } from 'features/feature-set/types';
import { selectIsSystemSession } from 'features/application/selectors';
import { resolveEventUserSaga } from 'features/users/utils/resolveEventUser';
import { User } from 'features/users/types';
import { EventUser } from 'services/signaling';

export function* onPollLaunchedSaga(action: ReturnType<typeof signalingPollLaunched>) {
  yield call(closeSharedPollNotificationSaga, action.payload.data.id);

  const isSystemSession: boolean = yield select(selectIsSystemSession);
  // show the polls panel if it is a system session
  if (isSystemSession) {
    yield put(sidePanelOpened('polls'));

    return;
  }

  const canTakePolls: boolean = yield call(hasPermissionsSaga, PermissionTypes.takePolls);
  if (!canTakePolls) {
    return;
  }

  const openedPanel: SidePanelType = yield select(selectSidePanel);
  if (openedPanel === 'polls') {
    // show only if the polls panel is not opened
    return;
  }

  const { initiator, data } = action.payload;
  const resolvedInitiator: User | EventUser | undefined = yield call(
    resolveEventUserSaga,
    initiator.id
  );
  const initiatorName = resolvedInitiator?.name;

  const actionNotificationThunk: Action = yield call(
    addActionNotification,
    {
      content: i18n.t('notifications:polls.request_to_vote.content', {
        username: initiatorName,
      }),
      okText: i18n.t('notifications:polls.request_to_vote.btn_ok_label'),
      okAction: sidePanelOpened('polls'),
      initiator: resolvedInitiator,
      scope: [FeatureFlag.polls, 'poll_request_vote'],
    },
    {
      toastId: `poll_request_vote_${data.id}`,
    }
  );

  yield put(actionNotificationThunk);
}
